import { styled } from 'buttered';
import Head from 'next/head';

let Wrapper = styled('div')`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
    Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  transition: all 0.4s;
  z-index: 99999;

  &.hide {
    opacity: 0;
    pointer-events: none;
  }

  svg {
    width: 110px;
    margin: 0px auto;
    display: block;
  }

  .loading-text {
    text-align: center;
    font-size: 18px;
    margin: 30px 0px 0px 0px;
  }

  .loading-text h1 {
    font-size: 30px;
    font-weight: 600;
    margin: 0px 0px 6px 0px;
  }

  .loading-text p {
    font-size: 16px;
    margin: 0px;
  }
`;

export let Updating = () => {
  return (
    <Wrapper className="loading loading-primary">
      <Head>
        <script>{`window._update_landing_mode = true;`}</script>
        <script src="https://version.weekrise.com/index.js" async defer />
      </Head>

      <div className="loading-inner">
        <svg viewBox="0 0 34 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0)">
            <path
              d="M4.73682 9.73684C4.73682 1.71855 6.96629 0 17.3684 0C27.7705 0 30 1.71855 30 9.73684C30 17.7551 27.7705 19.4737 17.3684 19.4737C6.96629 19.4737 4.73682 17.7551 4.73682 9.73684Z"
              fill="#2481FF"
              className="box-1"
            />
            <path
              d="M0 13.421C0 7.13646 1.34697 5.78946 7.63158 5.78946C13.9162 5.78946 15.2632 7.13646 15.2632 13.421C15.2632 19.7056 13.9162 21.0526 7.63158 21.0526C1.34697 21.0526 0 19.7056 0 13.421Z"
              fill="#FFD707"
              className="box-2"
            />
            <path
              d="M8.42108 20.2631C8.42108 12.2449 10.6041 10.5263 20.7895 10.5263C30.9749 10.5263 33.1579 12.2449 33.1579 20.2631C33.1579 28.2814 30.9749 30 20.7895 30C10.6041 30 8.42108 28.2814 8.42108 20.2631Z"
              fill="#FAACA8"
              className="box-3"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="33.1579" height="30" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <div className="loading-text">
          <h1>Weekrise</h1>

          <p>
            Weekrise is undergoing maintenance.
            <br />
            We are currently shipping the next generation of Weekrise.
            <br />
            <br />
            This page will refresh when it's are ready.
          </p>
        </div>
      </div>
    </Wrapper>
  );
};

export default Updating;
